export const firebaseConfig = {
//   apiKey: 'AIzaSyBsVVpEDrlNPEmshLcmOuE0FxhjPn0AqMg',
//   authDomain: 'todo-react-redux.firebaseapp.com',
//   databaseURL: 'https://todo-react-redux.firebaseio.com',
//   storageBucket: 'firebase-todo-react-redux.appspot.com'
// };
  apiKey: "AIzaSyA9gyoEzIZtuXuU-7kjsutMDzgFMQ-ggg8",
  authDomain: "resplendent-inferno-6555.firebaseapp.com",
  databaseURL: "https://resplendent-inferno-6555.firebaseio.com",
  projectId: "resplendent-inferno-6555",
  storageBucket: "resplendent-inferno-6555.appspot.com",
  messagingSenderId: "334072765336"
};



// WEBPACK FOOTER //
// ./src/firebase/config.js